// GPSLive's own web app (Change #100398 / #100403). follow/{imei} is its
// single-device tracking page; live-map shows the whole account. Both need
// the user to be logged in to GPSLive.
export const GPSLIVE_WEB_URL = "https://gpslive.co.uk";

export const gpsLiveDeviceUrl = (d) => {
  const imei = d?.DeviceImei || d?.ProviderDeviceId;
  return imei
    ? `${GPSLIVE_WEB_URL}/follow/${encodeURIComponent(imei)}`
    : `${GPSLIVE_WEB_URL}/live-map`;
};
